export const fetchApplicationVersion = async () => {
  return fetch('/application-version.json')
    .then((resp) => resp.json())
    .then((data) => data['application-version']);
};
